export const FBC_BACKUP_COOKIE_NAME = 'fbclid_bl_backup'

export const getCookieByName = function (name: string): string | null {
  const cookies: string[] = document.cookie.split(';')
  const cookie: string | undefined = cookies.find((cookie) =>
    cookie.trim().startsWith(`${name}=`)
  )
  if (!cookie) {
    return null
  }
  return cookie.split('=')[1]
}

// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
export const getFBPCookie = function (): string | null {
  try {
    return getCookieByName('_fbp')
  } catch (e) {
    return null
  }
}

export const getFBCCookie = function (): string | null {
  try {
    const cookie = getCookieByName('_fbc')
    if (!cookie) {
      return getCookieByName(FBC_BACKUP_COOKIE_NAME)
    }
    return cookie
  } catch (e) {
    return null
  }
}
